import React from 'react';

interface MainScreenProps {
    onMateSignin: () => void;
    onEmailSignin: () => void;
}

const MainScreen: React.FC<MainScreenProps> = ({ onMateSignin, onEmailSignin }) => {
    return (
        <div className="main-signin">
            <div className="login-header">
                <h1>{"Welcome to MATE"}</h1>
                <p>{"Sign in to connect with Korean friends!"}</p>
            </div>

            <button
                type="button"
                className="mate-signin-button"
                onClick={onMateSignin}
            >
                {"Sign in with MATE"}
                <div className="mate-icons">
                    <svg className="ios-icon" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                    </svg>
                    <svg className="android-icon" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M17.523 15.3414c-.5511 0-.9993-.4486-.9993-.9997s.4482-.9993.9993-.9993c.5511 0 .9993.4483.9993.9993.0001.5511-.4482.9997-.9993.9997m-11.046 0c-.5511 0-.9993-.4486-.9993-.9997s.4482-.9993.9993-.9993c.5511 0 .9993.4483.9993.9993 0 .5511-.4482.9997-.9993.9997m11.4045-6.02l1.9973-3.4592a.416.416 0 00-.1518-.5972.416.416 0 00-.5972.1518l-2.0223 3.5046C15.5889 8.2231 13.8956 7.8098 12.0034 7.8098c-1.8922 0-3.5855.4133-5.2077 1.0648L4.7734 5.4592a.4161.4161 0 00-.5972-.1518.416.416 0 00-.1518.5972l1.9973 3.4592C2.6889 11.1867.3432 14.6589 0 18.761h24c-.3432-4.1021-2.6889-7.5743-6.1185-9.4796"/>
                    </svg>
                </div>
            </button>

            <div className="download-app-section">
                <div className="divider">
                    <span>{"Don't have the app?"}</span>
                </div>
                <div className="qr-code-container">
                    <a href="https://koreanmate.onelink.me/Tkco/y94asact" target="_blank" rel="noopener noreferrer">
                        <img
                            src="https://static.koreanmate.app/download_app.png"
                            alt="Download MATE App QR Code"
                            className="download-qr-code"
                        />
                    </a>
                    <p className="qr-text">{"Scan or click to download MATE app"}</p>
                </div>
            </div>
        </div>
    );
};

export default MainScreen;